import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch, useHistory } from 'react-router-dom';
import PageContainer from '$components/PageContainer';
import AssessmentItems from '$components/AssessmentItems';
import Error from '$components/Error';
import Assignments from '$components/Assignments';
import * as TYPES from '$variables/types';
import { STUDENT } from '$variables/constants';

const AssignmentsPage = ({
  fetchAssessmentItems,
  fetchAssignments,
  assessmentItems,
  assessmentItemsLoading,
  spaceId,
  error,
  assignments,
  assignmentsLoading,
  mapAssignments,
  clearMapAssignmentsError,
  mapAssignmentsError,
  mapAssignmentsLoading,
  mapAssignmentsSuccessful,
  isGeneratingCsv,
  exportGrades,
  isInitiatingExport,
  launchTurnitinAssignment,
  createAssignment,
  isCreatingAssignment,
  isManualAssignmentsEnabled,
  isGradePassBackDisabled,
  viewAs,
  ltiProviders,
  fetchLtiProviders,
  ltiProvidersLoading,
}) => {
  useEffect(() => {
    fetchAssessmentItems({ spaceId });
    fetchAssignments({ spaceId });
    fetchLtiProviders();
  }, [spaceId]);

  const { url } = useRouteMatch();
  const routeHistory = useHistory();

  const handleClick = (id) => {
    routeHistory.push(`${url}/assignment/${id}`);
  };

  if (error) {
    return <Error />;
  }

  return (
    <PageContainer withSideBar={viewAs !== STUDENT}>
      <AssessmentItems
        assessmentItems={assessmentItems}
        assignments={assignments}
        mapAssignments={mapAssignments}
        clearMapAssignmentsError={clearMapAssignmentsError}
        mapAssignmentsError={mapAssignmentsError}
        mapAssignmentsLoading={mapAssignmentsLoading}
        mapAssignmentsSuccessful={mapAssignmentsSuccessful}
        isGeneratingCsv={isGeneratingCsv}
        exportGrades={exportGrades}
        isInitiatingExport={isInitiatingExport}
        assessmentItemsLoading={assessmentItemsLoading}
        isGradePassBackDisabled={isGradePassBackDisabled}
        viewAs={viewAs}
      />
      <Assignments
        onClick={handleClick}
        assignments={assignments}
        ltiProviders={ltiProviders}
        ltiProvidersLoading={ltiProvidersLoading}
        assignmentsLoading={assignmentsLoading}
        launchTurnitinAssignment={launchTurnitinAssignment}
        spaceId={spaceId}
        createAssignment={createAssignment}
        isCreatingAssignment={isCreatingAssignment}
        isManualAssignmentsEnabled={isManualAssignmentsEnabled}
        viewAs={viewAs}
      />
    </PageContainer>
  );
};

AssignmentsPage.propTypes = {
  assessmentItems: PropTypes.arrayOf(TYPES.AssessmentItem).isRequired,
  assessmentItemsLoading: PropTypes.bool.isRequired,
  fetchAssessmentItems: PropTypes.func.isRequired,
  fetchAssignments: PropTypes.func.isRequired,
  mapAssignments: PropTypes.func.isRequired,
  clearMapAssignmentsError: PropTypes.func.isRequired,
  spaceId: PropTypes.string.isRequired,
  assignments: PropTypes.arrayOf(TYPES.Assignment).isRequired,
  assignmentsLoading: PropTypes.bool.isRequired,
  error: TYPES.ErrorType,
  mapAssignmentsError: PropTypes.string,
  mapAssignmentsLoading: PropTypes.bool.isRequired,
  mapAssignmentsSuccessful: PropTypes.bool.isRequired,
  isGeneratingCsv: PropTypes.bool.isRequired,
  exportGrades: PropTypes.func.isRequired,
  isInitiatingExport: PropTypes.bool.isRequired,
  launchTurnitinAssignment: PropTypes.func.isRequired,
  createAssignment: PropTypes.func.isRequired,
  isCreatingAssignment: PropTypes.bool.isRequired,
  isManualAssignmentsEnabled: PropTypes.bool,
  viewAs: TYPES.ViewAs.isRequired,
  isGradePassBackDisabled: PropTypes.bool,
  ltiProviders: PropTypes.arrayOf(TYPES.LtiProvider),
  fetchLtiProviders: PropTypes.func.isRequired,
  ltiProvidersLoading: PropTypes.bool.isRequired,
};

AssignmentsPage.defaultProps = {
  error: null,
  mapAssignmentsError: null,
  isManualAssignmentsEnabled: false,
  isGradePassBackDisabled: false,
  ltiProviders: [],
};

export default AssignmentsPage;
